export default "__VITE_ASSET__WqW5E38G__"